<template>
  <div class="wrapper">
    <v-head>
      <!-- <v-tags></v-tags> -->
    </v-head>
    <!-- <v-sidebar></v-sidebar> -->
    <div class="content-box" :class="{'content-collapse':collapse}">
      <div
        class="content fff"
        style="height: 100%;"
        v-loading.fullscreen.lock="$store.state.loading"
        element-loading-text="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <transition name="move" mode="out-in">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" class="page"></router-view>
          </keep-alive>
        </transition>
        <transition name="move" mode="out-in">
          <router-view class="page" v-if="!$route.meta.keepAlive"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import vHead from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import vTags from "./Tags.vue";
import bus from "./bus";
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      isRouterAlive: true
    };
  },
  components: {
    vHead,
    vSidebar,
    vTags
  },
  methods: {
    init() {
      bus.$on("collapse", msg => {
        this.collapse = msg;
      });
      // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
      bus.$on("tags", msg => {
        let arr = [];
        for (let i = 0, len = msg.length; i < len; i++) {
          msg[i].name && arr.push(msg[i].name);
        }
        this.tagsList = arr;
      });
    }
  },
  created() {
    this.init();
  }
};
</script>
<style lang="less" scoped>
.nav {
  height: 32px;
  line-height: 32px;

  span:nth-child(1) {
    font-size: 12px;
    color: #c0c4cc;
    letter-spacing: 0;
  }
  /*span:nth-child(2) {*/
  /*    font-size: 12px;*/
  /*    color: #4E5155;*/
  /*    padding: 0 4px;*/
  /*    letter-spacing: 0;*/
  /*}*/

  /*span:nth-child(1) {*/
  /*    font-size: 12px;*/
  /*    color: #4E5155;*/
  /*    letter-spacing: 0;*/
  /*}*/
}
</style>